<template>
  <div class="home">


  <router-link to="/abs-new">Nuovo Abstract</router-link>



    <!-- 
    <br />
    <div class="row">
      <div class="col col-s4"><router-link to="inside/info-generali/quote" class="btn">Iscriviti Subito</router-link> </div>

      <div class="col col-s4"><router-link to="inside/info-generali/abstract" class="btn">Invia Abstract</router-link></div>

      <div class="col col-s4"><a href="/2017/documenti/savethedate.pdf" class="btn" target="_blank">Programma</a></div>
    </div>
    

    <img src="../assets/home.jpg" style="width:100%;" />


    <div v-html="page"></div>

    <el-carousel class="combustion" :interval="5000" arrow="always" :height="'440px'">
      <el-carousel-item><img src="../assets/ipp01.jpg" height="440px" /></el-carousel-item>
      <el-carousel-item><img src="../assets/ipp02.jpg" height="440px" /></el-carousel-item>
      <el-carousel-item><img src="../assets/ipp03.jpg" height="440px" /></el-carousel-item>
      <el-carousel-item><img src="../assets/ipp04.jpg" height="440px" /></el-carousel-item>
    </el-carousel>
-->

  </div>
</template>

<script>


export default {
  name: 'home',
  data () {
    return {
      title:'',
      page: ''
    }
  },
  created(){
    var parent = this
    /*
    this.axios.get('page/home.html',{responseType: 'document'})
    .then(function (response) {
      parent.page = response.request.response.body.children.item(1).innerHTML
      
    })
    */
  }
}
</script>


<style scoped>
.combustion div.el-carousel__container {
  height: 440px !important;
  border:10px solid red;
  width: 500px;
}
.home a.btn{
  display:block;
  width: 100%;
  height: 3.8rem;
  color:#ffffff;
  text-align: center;
  line-height: 3.8rem;
  font-size: 1.8rem;
  font-weight: bold;
  background: darkred;
  border-color: darkred;
}.home a.main{
  display:block;
  font-size:2.3rem;
  text-align: center;
  color:darkred;
  font-weight: bold;
  padding:20px 0;
}
</style>



// WEBPACK FOOTER //
// Home.vue?542d6591